/*!
 * Copyright (c) 2022 WEBLIFE
 *
 * Permission is granted to use this file for the period specified in the contract 
 * between WEBLIFE and the client. Usage of this file beyond the contract period 
 * is strictly prohibited unless an extended license or written permission is obtained.
 *
 * Modifying or editing this file without prior written consent from WEBLIFE 
 * is not permitted.
 *
 * THE FILE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, 
 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A 
 * PARTICULAR PURPOSE AND NONINFRINGEMENT.
 */
document.addEventListener("DOMContentLoaded",(function(){
  document.querySelectorAll(".rich-text").forEach((function(richText){
    const childDiv=richText.querySelector(".rich-text__blocks");
    if(!childDiv)return;
    // カートページのリッチテキストセクションは除外
    if(richText.closest('[id*="rich_text_3tARUG"]'))return;
    // 子要素（ブロック）が1つでもあれば表示を維持する
    const hasVisibleContent=childDiv.children.length>0||""!==childDiv.textContent.trim();
    if(!hasVisibleContent){richText.style.display="none"}
  }))
}));



